// src/features/payment/hooks/useCartData.ts
import { useState, useEffect } from "react";
import { Product } from "../types/payment";
import api from "../../../../../../features/auth/axiosConfig";
import { errorHandling } from "src/shared/utils/errorHandling";

export const useCartData = (cartId?: string | null) => {
  const [cartProducts, setCartProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!cartId) return;

    const fetchCartData = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/app/v1/pos/shopping_cart/${cartId}`);
        const categoryData: Product[] = response.data.result;
        setCartProducts(categoryData);
      } catch (error) {
        errorHandling(error);
      } finally {
        setLoading(false);
      }
    };

    fetchCartData();
  }, [cartId]);

  return { cartProducts, loading };
};
